module.exports = __webpack_public_path__ + "img/23.e59fd428.jpg";